import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Image , Icon , Header , Menu , Segment } from 'semantic-ui-react';
import floorPlanImg from '../../assets/feature/floorPlan.png';
import menuImg from '../../assets/feature/menu.png';
import summaryImg from '../../assets/feature/summary.png';
import settingImg from '../../assets/feature/setting.png';
import { browserHistory } from "react-router";

const styles = {
  headerImg : {
    width : '50px',
    margin : '0px 10px 0px 0px',
    padding : '0px'
  },
  featureMenu : {
    overflow : 'scroll' ,
    padding: '0px 5px'
  },
  featureDiscription : {
    margin : '10px',
    minHeight : '20vh',
    fontSize : 20,
    width : '95%'
  }
}

class MobileFeaturesDisplay extends Component {
  constructor(props){
    super(props);
    this.state = {
      features : {
        floorPlan : {
          image : floorPlanImg ,
          functions : [{ name : 'addInvoice' , description : 'addInvoiceDesc' }, { name : 'amendInvoice' , description : 'amendInvoiceDesc' } , { name : 'deleteInvoice' , description : 'deleteInvoiceDesc' } , { name : 'changeTable' , description : 'changeTableDesc' } , { name : 'checkoutInvoice' , description : 'checkoutInvoiceDesc' } , { name : 'shareTable' , description : 'shareTableDesc' }]
        },
        menu : {
          image : menuImg ,
          functions : [{ name : 'menu' , description : 'menuDesc' },{ name : 'category' , description : 'catDesc' },{ name : 'item' , description : 'itemDesc' },{ name : 'option' , description : 'optionDesc' },{ name : 'set' , description : 'setDesc' }]
        },
        setting : {
          image : settingImg ,
          functions : [{ name : 'restaurant' , description : 'restaurantDesc' },{ name : 'workflow' , description : 'workFlowDesc' },{ name : 'staff' , description : 'staffDesc' },{ name : 'serviceCharge' , description : 'serviceChargeDesc' },{ name : 'discount' , description : 'discountDesc' },{ name : 'printer' , description : 'printerDesc' },{ name : 'floorPlan' , description : 'floorPlanDesc' }]
        },
        summary : {
          image : summaryImg ,
          functions : [{ name : 'summary' , description : 'summaryDesc' }]
        },
      }
    }
  }
  renderFeature(featureName){
    const { features } = this.state;
    const { string , featureSelected } = this.props;
    let description = string['noFeatureSelected'];
    features[featureName]['functions'].map((featureObj)=>{
      description = (featureObj.name === featureSelected) ? string[featureObj.description] : description;
    });
    return (
      <Grid.Row key={featureName}>
        <Grid.Column>
          <Header as='h1'><Image src={features[featureName]['image']} style={styles.headerImg}/>{string[featureName]}</Header>
          {(features[featureName]['functions'].length > 0) ? <Menu secondary style={styles.featureMenu}>{features[featureName]['functions'].map((functionObj)=><Menu.Item key={functionObj.name} name={string[functionObj.name]} active={featureSelected === functionObj.name} onClick={()=>browserHistory.push({  pathname : '/features' , query : { device : 'mobileDevices' , feature : functionObj.name } })}/>)}</Menu> : null}
          <Segment style={styles.featureDiscription}><p>{description}</p></Segment>
        </Grid.Column>
      </Grid.Row>
    )
  }
  render(){
    const { features } = this.state;
    return (
      <Grid.Column width={11}>
        <Grid style={{ padding : '20px 0px' }}>
          {Object.keys(features).map((featureName)=>this.renderFeature(featureName))}
        </Grid>
      </Grid.Column>
    );
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string
  }
}

export default connect(mapStateToProps,null)(MobileFeaturesDisplay)



/** WEBPACK FOOTER **
 ** ./src/containers/features/mobileFeaturesDisplay.js
 **/